"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionHolder = void 0;
var react_1 = __importDefault(require("react"));
/**
 * This is a  helper non-vizual component meant to compute and hold the selection for other host components like: gantt, table, etc
 * The host component should call `addRemoveItems` and listen for selection change by setting `selectionChangedHandler`
 *
 * @author Daniela Buzatu
 */
var SelectionHolder = /** @class */ (function (_super) {
    __extends(SelectionHolder, _super);
    function SelectionHolder(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            selectedItems: []
        };
        return _this;
    }
    SelectionHolder.prototype.componentDidUpdate = function (prevProps) {
        var selectedItems = this.props.selectedItems;
        var prevSelectedItems = prevProps.selectedItems;
        if (selectedItems && !prevSelectedItems || !selectedItems && prevSelectedItems || selectedItems && prevSelectedItems && selectedItems.toString() !== prevSelectedItems.toString()) {
            selectedItems = this.props.selectedItems ? this.props.selectedItems : [];
            this.setState({ selectedItems: selectedItems });
            // Notify the host component about selection change
            if (this.props.selectionChangedHandler) {
                this.props.selectionChangedHandler(selectedItems);
            }
        }
    };
    /**
     * Should be called by the host component when an item is clicked or right clicked (contextMenu event) or when user clicks outside any selectable items (for reseting the selection),
     * or when any other user action intended to select items happens
     * (e.g. in gantt: drawing selection rectangle)
     * It adds/removes from selection (in case of multiple selection) or set the selection (in case of single selection)
     *
     * Usually the right click on the host component works just as a left click regarding the selection.  So the host component calls should be the same in both click cases
     */
    SelectionHolder.prototype.addRemoveItems = function (itemsKeys, event) {
        if (this.props.selectedItems) {
            return;
        }
        if (event.type == "mousedown" && event.button == 2) {
            if (itemsKeys.length == 1 && this.state.selectedItems.includes(itemsKeys[0])) {
                // right click on a selected item => doesn't change the selection
                return;
            }
        }
        var newSelection;
        if (!(event.ctrlKey || event.shiftKey)) {
            // Single selection
            newSelection = __spreadArray([], itemsKeys, true);
        }
        else {
            // Multiple selection
            var oldSelection = this.state.selectedItems;
            newSelection = oldSelection.slice();
            itemsKeys.forEach(function (itemKey) {
                var idx = newSelection.indexOf(itemKey);
                if (idx > -1) {
                    // already in selection => remove it
                    newSelection.splice(idx, 1);
                }
                else {
                    // not in selection => add it
                    newSelection.push(itemKey);
                }
            });
        }
        this.setSelection(newSelection);
    };
    SelectionHolder.prototype.setSelection = function (itemsKeys) {
        this.setState({ selectedItems: itemsKeys });
        // Notify the host component about selection change
        if (this.props.selectionChangedHandler) {
            this.props.selectionChangedHandler(itemsKeys);
        }
    };
    SelectionHolder.prototype.render = function () {
        return null;
    };
    return SelectionHolder;
}(react_1.default.Component));
exports.SelectionHolder = SelectionHolder;
//# sourceMappingURL=SelectionHolder.js.map